export default __webpack_public_path__ + "static/media/small_brett.3c57783c.png";